const quickTweens = [
  {
    group: "Zoom",
    name: 'Zoom In',
    label: "In",
    property: 'scalebothglobal',
    from: 0,
    to: 1,
    tween: 'easeOutQuad',
    tags:['enter']
  },
  {
    group: "Zoom",
    name: 'Zoom Out',
    label: "Out",
    property: 'scalebothglobal',
    from: 1,
    to: 0,
    tween: 'easeInQuad',
    tags:['exit']
  },
  {
    group: "Slide",
    name: 'Slide In Left',
    label: "Left",
    property: 'x',
    from: -10,
    to: 0,
    tween: 'easeInQuad',
    tags:['enter']
  },
  {
    group: "Slide",
    name: 'Slide In Right',
    label: "Right",
    property: 'x',
    from: 10,
    to: 0,
    tween: 'easeOutCubic',
    tags:['enter']
  },
  {
    group: "Appear",
    name: 'Slide In Top',
    label: "Top",
    property: 'y',
    from: -10,
    to: 0,
    tween: 'easeOutCubic',
    tags:['enter']
  },
  {
    group: "Appear",
    name: 'Slide In Bottom',
    label: "Bottom",
    property: 'y',
    from: 10,
    to: 0,
    tween: 'easeOutCubic',
    tags:['enter']
  },
  {
    group: "Slide",
    name: 'Slide Out Left',
    label: "Left",
    property: 'x',
    from: 0,
    to: -10,
    tween: 'easeInQuad',
    tags:['exit']
  },
  {
    group: "Slide",
    name: 'Slide Out Right',
    label: "Right",
    property: 'x',
    from: 0,
    to: 10,
    tween: 'easeOutCubic',
    tags:['exit']
  },
  {
    group: "Appear",
    name: 'Slide Out Top',
    label: "Top",
    property: 'y',
    from: 0,
    to: -10,
    tween: 'easeOutCubic',
    tags:['exit']
  },
  {
    group: "Appear",
    name: 'Slide Out Bottom',
    label: "Bottom",
    property: 'y',
    from: 0,
    to: 10,
    tween: 'easeOutCubic',
    tags:['exit']
  },
  {
    group: "Appear",
    name: 'Slide In Top Bounce',
    label: "Top Bounce",
    property: 'y',
    from: -10,
    to: 0,
    tween: 'easeOutBack',
    tags:['enter']
  },
  {
    group: "Appear",
    name: 'Slide In Bottom Bounce',
    label: "Bottom Bounce",
    property: 'y',
    from: 10,
    to: 0,
    tween: 'easeOutBack',
    tags:['enter']
  },
  {
    group: "Slide",
    name: 'Slide In Left Bounce',
    label: "Left Bounce",
    property: 'x',
    from: -10,
    to: 0,
    tween: 'easeOutBack',
    tags:['enter']
  },
  {
    group: "Slide",
    name: 'Slide In Right Bounce',
    label: "Right Bounce",
    property: 'x',
    from: 10,
    to: 0,
    tween: 'easeOutBack',
    tags:['enter']
  },
  {
    group: "Fade",
    name: 'Fade In',
    label: "In",
    property: 'alpha',
    from: 0,
    to: 1,
    flip: true,
    tween: 'easeInCubic',
    tags: ['enter']
  },
  {
    group: "Fade",
    name: 'Fade In Half',
    label: "Half",
    property: 'alpha',
    from: 0.5,
    to: 1,
    tween: 'easeInCubic',
    tags: ['enter']
  },
  {
    group: "Fade",
    name: 'Fade In Transparent',
    label: "Transparent",
    property: 'alpha',
    from: 0.0,
    to: 0.5,
    tween: 'easeInCubic',
    tags: ['enter']
  },
  {
    group: "Fade",
    name: 'Fade Out',
    label: "Out",
    property: 'alpha',
    from: 1,
    to: 0,
    tween: 'easeOutCubic',
    tags:['exit']
  },
  {
    group: "Fade",
    name: 'Fade Out Half',
    label: "Out",
    property: 'alpha',
    from: 1,
    to: 0.5,
    tween: 'easeOutCubic',
    tags:['exit']
  },

  {
    group: "Zoom",
    name: 'Zoom In Bounce',
    label: "In Bounce",
    property: 'scalebothglobal',
    from: 0,
    to: 1,
    tween: 'easeOutBack',
    tags:['enter']
  },
  {
    group: "Zoom",
    name: 'Zoom Out Bounce',
    label: "Out Bounce",
    property: 'scalebothglobal',
    from: 1,
    to: 0,
    tween: 'easeInBack',
    tags:['exit']
  },
  {
    group: "Rotate",
    name: 'Rotate Left',
    label: "Left",
    property: 'rotation',
    from: 0,
    to: -360,
    tween: 'linear',
    tags:['enter', 'exit']
  },
  {
    group: "Rotate",
    name: 'Rotate Right',
    label: "Right",
    property: 'rotation',
    from: 0,
    to: 360,
    tween: 'linear',
    tags:['enter', 'exit']
  },
  {
    group: "Rotate",
    name: 'Rotate Bounce Right',
    label: "Bounce Right",
    property: 'rotation',
    from: 0,
    to: 25,
    tween: 'easeInOutBack',
    tags:['enter', 'exit']
  },
  {
    group: "Rotate",
    name: 'Rotate Bounce Left',
    label: "Bounce Left",
    property: 'rotation',
    from: 0,
    to: -25,
    tween: 'easeInOutBack',
    tags:['enter', 'exit']
  },
]

export default quickTweens;
